export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const WHATSAPP_NUMBER = process.env.REACT_APP_WHATSAPP_NUMBER || "34630579080";
export const DEPOSIT_EUR = 50;
export const LOYALTY_PERCENT = 10;

export const CONTACT = {
  email: "rent@rentamotenerife.es",
  phone: "+34 922 752 605",
  whatsappDisplay: "+34 630 57 90 80",
  instagram: "motostopacio",
  address: "Avenida Ernesto Sarti nº 2, Costa Adeje, Santa Cruz de Tenerife",
  lat: 28.0864373,
  lng: -16.7301124,
  mapEmbed: "https://www.openstreetmap.org/export/embed.html?bbox=-16.7401%2C28.0814%2C-16.7201%2C28.0914&layer=mapnik&marker=28.0864373%2C-16.7301124",
  directions: "https://www.google.com/maps/dir/?api=1&destination=28.0864373,-16.7301124",
};

export const EXTRAS_META = {
  helmet2: { short_flat: 5.0 }, // 2º casco: 5€ solo 1-2 días, incluido desde el 3.er día
  gloves: { flat: 5.0 },        // 2º par de guantes: 5€ pago único (el 1er par va incluido por ley)
  jacket1: { flat: 10.0 },
  jacket2: { flat: 10.0 },
  phone_holder: { flat: 5.0 },
  topcase: { per_day: 7.0 },
  full_insurance: { per_day: 12.0 },
  delivery: { flat: 25.0 },
};

export function extraPrice(key, days, tierDays, bike) {
  const meta = EXTRAS_META[key];
  if (!meta) return 0;
  const tier = tierDays != null ? tierDays : Math.max(Math.ceil(days), 1);
  if (meta.short_flat != null) return tier <= 2 ? meta.short_flat : 0;
  if (key === "full_insurance") return Math.round((bike?.insurance_per_day ?? meta.per_day) * days);
  return meta.flat || Math.round(meta.per_day * days);
}

export function dailyRate(bike, days) {
  if (days <= 2) return bike.price_1d;
  if (days <= 6) return Math.round((bike.price_3d / 3) * 100) / 100;
  return Math.round((bike.price_7d / 7) * 100) / 100;
}

// Facturación 24h con horas extra (Fase 2b): 1-4h=½ día · 4:01-10h=75% · +10h=día completo.
export function extraFraction(remHours) {
  if (remHours <= 0.02) return 0;
  if (remHours <= 4) return 0.5;
  if (remHours <= 7) return 0.75;
  return 1;
}

export function computeBilling(startISO, endISO, pickupTime, returnTime) {
  if (!startISO || !endISO) return { billable: 0, fullDays: 0, extra: 0, tierDays: 1, hours: 0 };
  const pu = new Date(`${startISO}T${pickupTime || "09:00"}:00`);
  const ret = new Date(`${endISO}T${returnTime || "17:30"}:00`);
  let hours = (ret - pu) / 3600000;
  if (!(hours > 0)) {
    const nights = Math.max(Math.round((new Date(endISO) - new Date(startISO)) / 86400000), 1);
    return { billable: nights, fullDays: nights, extra: 0, tierDays: Math.max(nights, 1), hours: nights * 24 };
  }
  const full = Math.floor(hours / 24);
  const rem = hours - full * 24;
  const extra = extraFraction(rem);
  const billable = Math.round(Math.max(full + extra, 1) * 100) / 100;
  return { billable, fullDays: full, extra, tierDays: Math.max(full, 1), hours: Math.round(hours * 10) / 10 };
}

export function quote(bike, days, extras, coupon, loyaltyPct, tierDays) {
  const tier = tierDays != null ? tierDays : Math.max(Math.ceil(days), 1);
  // importes redondeados a euros enteros (sin decimales tipo 42,99€)
  const rental = Math.round(dailyRate(bike, tier) * days);
  let extrasTotal = 0;
  extras.forEach((e) => {
    extrasTotal += extraPrice(e, days, tier, bike);
  });
  extrasTotal = Math.round(extrasTotal);
  let discount = 0;
  if (coupon) {
    discount = coupon.type === "percent"
      ? rental * coupon.value / 100
      : Math.min(coupon.value, rental + extrasTotal);
    discount = Math.round(discount);
  }
  let loyalty = 0;
  if (!coupon && loyaltyPct) {
    loyalty = Math.round(rental * loyaltyPct / 100);
  }
  return { rental, extrasTotal, discount, loyalty, total: Math.round(rental + extrasTotal - discount - loyalty) };
}

// Grupos de tarifa: la letra fija carnet requerido, precios y fianza
export const GROUPS = {
  B: { license: "A1 / B+3", price_1d: 39, price_3d: 111, price_7d: 238, deposit: 150 },
  C: { license: "A1 / B+3", price_1d: 43, price_3d: 119, price_7d: 253, deposit: 150 },
  E: { license: "A2", price_1d: 63, price_3d: 170, price_7d: 350, deposit: 250 },
  F: { license: "A2", price_1d: 85, price_3d: 235, price_7d: 470, deposit: 500 },
  G: { license: "A2", price_1d: 95, price_3d: 265, price_7d: 530, deposit: 500 },
  H: { license: "A", price_1d: 135, price_3d: 385, price_7d: 770, deposit: 750 },
  I: { license: "A", price_1d: 148, price_3d: 420, price_7d: 840, deposit: 750 },
};

export const LICENSE_TYPES = ["A1", "B", "A2", "A"];

// Edad mínima para reservar online: 25 años en TODAS las motos (si no, deben escribirnos).
export const bikeMinAge = () => 25;

// Estado operativo de la flota (panel admin). "alquilada" se pone sola al firmar
// la entrega y también puede marcarse a mano; "retornada" se pone sola al firmar la devolución.
export const BIKE_STATUS = {
  ok: { label: "Moto OK", cls: "bg-topacio-green text-white" },
  alquilada: { label: "En la calle / alquilada", cls: "bg-brand text-topacio-ink" },
  por_revisar: { label: "Por revisar", cls: "bg-brand text-topacio-ink" },
  revisada: { label: "Revisada", cls: "bg-emerald-600 text-white" },
  por_reparar: { label: "Por reparar", cls: "bg-topacio-red text-white" },
  danada: { label: "Averiada", cls: "bg-topacio-red text-white" },
  pendiente_pieza: { label: "Pendiente de pieza", cls: "bg-orange-500 text-white" },
  pendiente_limpiar: { label: "Pendiente limpiar", cls: "bg-sky-500 text-white" },
  en_lavadero: { label: "En el lavadero", cls: "bg-sky-600 text-white" },
  sin_itv: { label: "Sin ITV", cls: "bg-orange-600 text-white" },
  sin_seguro: { label: "Sin seguro", cls: "bg-orange-600 text-white" },
  retornada: { label: "De vuelta", cls: "bg-topacio-ink text-white" },
  bloqueada: { label: "Bloqueada", cls: "bg-black text-brand" },
};
// estados que impiden reservar en la web (avería/legal real o bloqueo manual).
// "alquilada"/lavadero/revisión NO bloquean: el estado es solo interno del equipo.
// "sin_seguro" tampoco bloquea el front por decisión del cliente (se gestiona internamente).
export const BIKE_HARD_BLOCKED = ["por_reparar", "pendiente_pieza", "presupuesto", "bloqueada", "danada", "sin_itv"];
export const bikeIsRideable = (b) => !BIKE_HARD_BLOCKED.includes(b.status || "ok");

// Protocolo de estado del vehículo (entrega/devolución)
export const CHECKLIST_ITEMS = [
  ["carroceria", "Carrocería sin golpes ni arañazos"],
  ["luces", "Luces e intermitentes"],
  ["neumaticos", "Neumáticos en buen estado"],
  ["espejos", "Espejos completos"],
  ["frenos", "Frenos responden"],
  ["casco", "Casco(s) entregado(s)"],
];
export const FUEL_LEVELS = ["reserva", "1/4", "1/2", "3/4", "lleno"];
export const PHOTO_ANGLES = [
  ["frontal", "Frontal"],
  ["lateral_derecha", "Lateral derecha"],
  ["lateral_izquierda", "Lateral izquierda"],
  ["trasera", "Trasera"],
];

// Fast Check: valida edad + carnet contra el requisito de la moto ("A1 / B+3" | "A2" | "A")
// Devuelve null si faltan datos, { ok: true } o { ok: false, code: "type" | "b3" | "age" }
export function fastCheckLicense({ birthdate, licenseType, licenseYear }, required, minAge = 0) {
  if (!birthdate || !licenseType || !licenseYear) return null;
  const birth = new Date(birthdate);
  if (isNaN(birth)) return null;
  const now = new Date();
  let age = now.getFullYear() - birth.getFullYear();
  const m = now.getMonth() - birth.getMonth();
  if (m < 0 || (m === 0 && now.getDate() < birth.getDate())) age -= 1;
  const yearsHeld = now.getFullYear() - Number(licenseYear);
  const L = licenseType;
  // norma de la casa: todo riesgo solo con 25 años Y 3 de antigüedad de carnet
  const base = { age, under25: age < 25, yearsHeld, noFullInsurance: age < 25 || yearsHeld < 3 };
  // edad mínima específica de la moto (grupo H y Honda Forza 750: 25 años)
  if (minAge && age < minAge) return { ok: false, code: "min_age", ...base };
  if (required === "A") {
    if (L !== "A") return { ok: false, code: "type", ...base };
    if (age < 20) return { ok: false, code: "age", ...base };
    return { ok: true, ...base };
  }
  if (required === "A2") {
    if (L !== "A2" && L !== "A") return { ok: false, code: "type", ...base };
    if (L === "A2" && age < 18) return { ok: false, code: "age", ...base };
    return { ok: true, ...base };
  }
  // "A1 / B+3" (125cc y scooters)
  if (["A1", "A2", "A"].includes(L)) {
    if (L === "A1" && age < 16) return { ok: false, code: "age", ...base };
    return { ok: true, ...base };
  }
  if (L === "B") {
    if (yearsHeld < 3) return { ok: false, code: "b3", ...base };
    return { ok: true, ...base };
  }
  return { ok: false, code: "type", ...base };
}
